import { render, staticRenderFns } from "./AxHeaderSearchResult.vue?vue&type=template&id=72ee0300&scoped=true&"
import script from "./AxHeaderSearchResult.vue?vue&type=script&lang=ts&"
export * from "./AxHeaderSearchResult.vue?vue&type=script&lang=ts&"
import style0 from "./AxHeaderSearchResult.vue?vue&type=style&index=0&id=72ee0300&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ee0300",
  null
  
)

export default component.exports